import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { notification } from 'antd';
import imeilogo from '../../assets/report/gearvu-logo.png';
import './ImeiFinder.css';
import errorSound from '../../assets/sounds/error-sound.mp3';
import Sidebar from '../Sidebar/Sidebar';

function ImeiFinder() {
  const [imei, setImei] = useState('');
  const [imeiMap, setImeiMap] = useState({});
  const [loading, setLoading] = useState(true);

  const playErrorSound = () => {
    const audio = new Audio(errorSound);
    audio.play();
  };

  useEffect(() => {
    const fetchImeiData = async () => {
      try {
        const response = await axios.get('/api/reports/dashboard');
        const fetchedImeiMap = {};
        response.data.reports.forEach((report) => {
          fetchedImeiMap[report.data.report.IMEI] = report.data.report.reportid;
        });
        setImeiMap(fetchedImeiMap);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching IMEI data:', error);
        notification.error({
          message: 'Error',
          description: 'Failed to load IMEI data. Please try again later.',
          placement: 'topRight',
        });
        setLoading(false);
      }
    };

    fetchImeiData();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (imeiMap[imei]) {
      // const reportId = imeiMap[imei];
      const baseUrl = window.location.origin;
      window.open(`${baseUrl}/report/${imei}`, '_blank');
    } else {
      playErrorSound();
      notification.error({
        message: 'No IMEI number record found!',
        description: 'No IMEI number record found! Please enter a correct IMEI number.',
        placement: 'topRight',
        duration: 5,
        style: { fontSize: '16px', color: '#FF4D4F' },
      });
    }
  };

  const handleInputChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, '');
    setImei(numericValue);
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <img
          src="https://i.pinimg.com/originals/65/ba/48/65ba488626025cff82f091336fbf94bb.gif"
          alt="Loading..."
        />
      </div>
    );
  }

  return (
    <div className="App">
      
       <Sidebar/>
      <div className="imei-finder">
        <div className="container">
          <div className="row np">
            <div className="col-md-12">
              <img src={imeilogo} className="img-fluid imei-logo" alt="Gearvu Logo" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <h2>
                <span>Device Inspection</span> Report Lookup
              </h2>
              <p>
                Enter your device’s IMEI number below to access your inspection report. <br />
                Once submitted, if a report is found, it will open in a new tab for easy viewing.
              </p>
              <form onSubmit={handleSubmit}>
                <div>
                  <span>IMEI NUMBER</span>
                  <input
                    size="1"
                    type="text"
                    name="imei"
                    id="imei"
                    value={imei}
                    onChange={handleInputChange}
                  />
                </div>
                <br />
                <button type="submit">View Report</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImeiFinder;